import { RecordButton } from "@rosc/ui/v32/record-button";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

// "Start visit" on a pre-chart draft: the ink pill with the record mark, as
// the recorder's Start recording (@rosc/ui RecordButton).
export const StartVisitButton = ({
  onClick,
  size = "default",
  className,
  testId = "start-visit",
  disabled = false,
}: {
  onClick: () => void;
  size?: "default" | "compact" | "large";
  className?: string;
  testId?: string;
  disabled?: boolean;
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <RecordButton
      className={className}
      data-testid={testId}
      disabled={disabled}
      label={t("preChart.startVisit")}
      size={size}
      onClick={onClick}
    />
  );
};
